import React, { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux';
import moment from "moment"
import Highcharts from 'highcharts'
import ReactHighcharts from 'highcharts-react-official';
import HighchartsNoData from 'highcharts/modules/no-data-to-display';
import { DISPLAY_DATE_FORMAT2 } from '../../../constants';
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
HighchartsNoData(Highcharts);

const UtilizationChart = (props) => {
  const { egId, searchParams/* , height */ } = props;
  const sourceDetailsById = useSelector(state => state.dashboard.leaderBoard.sourceListById.payload);
  const [graphData, setData] = useState(null);
  const [name, setName] = useState('chart');
  const chartRef = useRef(null);
  const sourceDetailList = Object.keys(sourceDetailsById).map(id => sourceDetailsById[id]);

  useEffect(() => {
    const fromDate = moment(searchParams.custom.from);
    const toDate = moment(searchParams.custom.to);
    let nameFormat = `Utilization_${moment(fromDate).format("DD MMM YY")} to ${moment(toDate).format("DD MMM YY")}`;

    if (searchParams.customRange === "todate" || searchParams.customRange === "planned") {
      searchParams.customRange === "todate" ? nameFormat = "Utilization_toDate" : nameFormat = "Utilization_planned";
    }

    setName(nameFormat);
  }, [searchParams]);

  // useEffect(() => {
  //   if (chartRef && chartRef.current && chartRef.current.chart) {
  //     chartRef.current.chart.setSize(null, height, false); 
  //   }
  // }, [height]);

  useEffect(() => {
    const selectedId = sourceDetailList.filter(e => e.equipmentGroupId === egId);

    if (selectedId.length !== 0) {
      let utilizationsData = selectedId[0].utilizationPerDay ? selectedId[0].utilizationPerDay : [0];

      let sortedValues = utilizationsData.sort(function (a, b) {
        return new Date(a.date) - new Date(b.date);
      });

      let utilizationDates = sortedValues.map((data) => moment(data.date).format(DISPLAY_DATE_FORMAT2));
      let utilizations = sortedValues.map((data) => data.utilization < 100 ? data.utilization : 100);
      setData({
        date: utilizationDates,
        percentage: utilizations,
        name: selectedId[0].equipmentGroupName
      });
    }
  }, []);

  let value = {
    chart: {
      type: 'column'
    },
    title: {
      text: ''
    },
    xAxis: {
      categories: graphData !== null ? graphData.date : [0],
      crosshair: true
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Utilization %'
      }
    },
    tooltip: {
      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
        '<td style="padding:0"><b>{point.y:.1f} %</b></td></tr>',
      footerFormat: '</table>',
      shared: true,
      useHTML: true,
      enabled: false
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: '{point.y:.0f}%'
        }
      },
    },
    series: [{
      name: graphData !== null ? graphData.name : "N/A",
      data: graphData !== null ? graphData.percentage : []

    }],
    exporting: {
      filename: name,
      buttons: {
        contextButton: {
          menuItems: [
            'viewFullscreen',
            'printChart',
            'separator',
            'downloadPNG',
            'downloadJPEG',
            'downloadPDF',
            'downloadSVG',
            'downloadCSV'
          ]
        }
      }
    },
  }

  return <ReactHighcharts ref={chartRef} config={value} options={value}></ReactHighcharts>;
}

export default UtilizationChart;
